import { Radio, RadioGroup } from 'react-aria-components';
import styled from 'styled-components';

export const Fieldset = styled(RadioGroup)<{ $hasDiscreteFields: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${props => (props.$hasDiscreteFields ? 'var(--spacing-base)' : '0')};
  width: 100%;

  & .react-aria-Label {
    margin-block-end: ${props => (props.$hasDiscreteFields ? '0' : 'var(--spacing-base)')};
    font-size: var(--font-size-text-lg);
    font-weight: var(--font-weight-semibold);
    line-height: 28px;
  }

  &:has([data-focus-visible]) {
    box-shadow: var(--shadow-focus);
  }

  & .react-aria-FieldError {
    margin-block-end: var(--spacing-small);
    font-size: var(--font-size-text-sm);
    font-weight: var(--font-weight-bold);
    color: var(--error-600);
  }
`;

export const RadioField = styled(Radio)<{ $isDiscrete: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-small);
  width: 100%;
  max-width: 422px;
  padding: var(--spacing-large);
  background: var(--white);
  border-color: var(--grey-300);
  border-radius: var(--radius-base);
  border-style: solid;
  border-width: 1px 1px 0 1px;

  ${props =>
    props.$isDiscrete
      ? `
  border-width: 1px;
      `
      : `
  border-width: 1px 1px 0 1px;
  &:first-of-type {
    border-radius: var(--radius-base) var(--radius-base) 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 var(--radius-base) var(--radius-base);
    border-bottom-width: 1px;
  }
    `}

  &[data-selected] {
    background: var(--grey-100);
    border-color: var(--brand-900);
    border-bottom-width: 1px;
  }
`;

export const Label = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xsmall);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 1.5rem;
  color: var(--black);

  &:is([data-disabled] &) {
    color: var(--grey-300);
  }

  & span {
    color: var(--grey-500);

    &:is([data-selected] &) {
      color: var(--grey-600);
    }

    &:is([data-disabled] &) {
      color: var(--grey-300);
    }
  }
`;

export const RadioButton = styled.div`
  display: block;
  width: 18px;
  height: 18px;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-fullyrounded);

  &:is([data-selected] &) {
    border: 6px solid var(--brand-900);
  }

  &:is([data-focus-visible] &) {
    box-shadow: 0 0 0 2px var(--white), 0 0 0 4px rgb(15 23 43);
  }

  &:is([data-disabled] &) {
    background: var(--grey-50);
    border-color: var(--grey-100);
  }
`;

export const Cta = styled.div`
  & button {
    font-size: var(--font-size-text-xs);
    font-weight: var(--font-weight-regular);
    line-height: 1.5;
  }
`;

export const Icon = styled.div`
  & svg {
    width: 18px;
  }
`;

export const Price = styled.div<{ $isFree: boolean }>`
  font-size: var(--font-size-text-sm);
  font-weight: ${props => (props.$isFree ? 'var(--font-weight-regular)' : 'var(--font-weight-semibold)')};
  text-transform: ${props => (props.$isFree ? 'uppercase' : 'none')};
  line-height: 1.5;

  &:is([data-disabled] &) {
    color: var(--grey-300);
  }
`;
